/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */

// Material Dashboard 2 React - Tables Page with Filters
import Grid from "@mui/material/Grid";
import { Card, FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// React
import { useEffect, useState } from "react";
import persistedExpensesDataTable from "layouts/tables/data/persistedExpensesDataTable";
import DataTable from "examples/Tables/DataTable";
import MDTypography from "components/MDTypography";
import mattersTableData from "layouts/tables/data/mattersTableData";
import dayjs from "dayjs";
import { addExpense, deleteExpense } from "apis/api";
const formatDate = (date) => (date ? dayjs(date).format("YYYY-MM-DD") : null);
function Expenses() {
    const [persistedExpensesColumns, setPersistedExpensesColumns] = useState([]);
    const [persistedExpensesRows, setpersistedExpensesRows] = useState([]);
    const [loadingpersistedExpenses, setLoadingpersistedExpenses] = useState(false);
    const [mattersColumns, setMattersColumns] = useState([]);
    const [mattersRows, setMattersRows] = useState([]);
    const [loadingMatters, setLoadingMatters] = useState(false);
    const [attorneys, setAttorneys] = useState(undefined);
    const [selectedAttorney, setSelectedAttorney] = useState("");
    const [filtredExpenses, setFiltredExpenses] = useState([]);
    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [expenseToDelete, setExpenseToDelete] = useState(null);
    const [newExpense, setNewExpense] = useState({
        date: "",
        selectedDate: "",
        attorney: "",
        AttorneyDirectExpenses: "",
        TotalGeneralExpenses: "",
    });

    const loadMattersData = async () => {
        setLoadingMatters(true);
        const { mattersColumns, mattersRows, mattersData } = await mattersTableData({
            issuedAfter: formatDate(dayjs("2025-01-01")),
            issuedBefore: formatDate(dayjs()),
        });

        //setMattersColumns(mattersColumns);
        //setMattersRows(mattersRows);

        setLoadingMatters(false);
        let cleanedData = mattersData.data.filter(
            (item) => item && item.state !== "void" && item.state !== "deleted"
        );
        cleanedData = mattersData.data.filter(
            (item) =>
                item &&
                item.state !== "void" &&
                item.state !== "deleted" &&
                item.originating_attorney !== null
        );
        setMattersRows(cleanedData);
    };

    const loadPersistedExpensesData = async () => {
        setLoadingpersistedExpenses(true);
        const { persistedExpensesColumns, persistedExpensesRows, persistedExpensesData } =
            await persistedExpensesDataTable();


        setPersistedExpensesColumns(persistedExpensesColumns.filter(item =>
            ["date", "AttorneyDirectExpenses", "TotalGeneralExpenses"].includes(item.accessor)
        ));

        setpersistedExpensesRows(persistedExpensesData);
        setPersistedExpensesColumns((prevCols) => [
            ...prevCols,
            {
                Header: "Actions",
                accessor: "actions",
                align: "center",
                Cell: ({ row }) => (
                    <Button
                        variant="contained"
                        onClick={() => handleDeleteClick(row.original)}
                        size="small"
                        sx={{
                            backgroundColor: 'red !important',
                            color: 'white !important',
                        }}
                    >
                        Delete
                    </Button>
                ),
            },
        ]);
        setLoadingpersistedExpenses(false);
    };
    const addNewExpense = async () => {
        if (newExpense.date && newExpense.AttorneyDirectExpenses && newExpense.TotalGeneralExpenses) {


            const response = await addExpense(newExpense);

            setNewExpense({
                date: "",
                selectedDate: "",
                attorney: "",
                AttorneyDirectExpenses: "",
                TotalGeneralExpenses: "",
            });

        }
    }
    const handleDeleteClick = (expense) => {
        setExpenseToDelete(expense);
        setDeleteDialogOpen(true);
    };

    const confirmDelete = async () => {

        setDeleteDialogOpen(false);
        setExpenseToDelete(null);

        await deleteExpense(selectedAttorney, expenseToDelete.date);
        setpersistedExpensesRows((prev) =>
            prev.filter((item) => item.date !== expenseToDelete.date)
        );
    };

    useEffect(() => {
        loadPersistedExpensesData();
        loadMattersData();
    }, []);
    useEffect(() => {
        if (mattersRows && mattersRows.length > 0 && persistedExpensesRows) {
            const originating = mattersRows.map(
                (item) => item.originating_attorney.name
            );
            const responsible = mattersRows.map(
                (item) => item.responsible_attorney.name
            );

            const expenses = persistedExpensesRows.map(
                (item) => item["attorney"]
            );
            const newattorneys = []
                .concat(originating)
                .concat(responsible)
                .concat(expenses)
                .filter((item) => item !== "");
            const distinctAttorney = Array.from(new Set(newattorneys));

            const attorneyList = distinctAttorney.map((atty, i) => {
                return {
                    label: atty,
                    value: atty,
                };
            });


            setAttorneys(attorneyList);
        }
    }, [mattersRows, persistedExpensesRows]);
    useEffect(() => {
        const filtered = persistedExpensesRows
            .filter((item) => item.attorney === selectedAttorney)
            .sort((a, b) => {
                const dateA = new Date(`${a.date} 01`);
                const dateB = new Date(`${b.date} 01`);
                return dateA - dateB;
            })
            .map(({ date, AttorneyDirectExpenses, TotalGeneralExpenses }) => ({
                date,
                AttorneyDirectExpenses,
                TotalGeneralExpenses
            }));


        setFiltredExpenses(filtered);

    }, [selectedAttorney, persistedExpensesRows])

    const inputStyle = {
        width: 250,
        backgroundColor: "white",
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={3} pb={3}>
                <Dialog
                    open={deleteDialogOpen}
                    onClose={() => setDeleteDialogOpen(false)}
                >
                    <DialogTitle>Confirm Deletion</DialogTitle>
                    <DialogContent>
                        Are you sure you want to delete this expense entry?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
                        <Button
                            onClick={confirmDelete}
                            variant="contained"
                            sx={{
                                backgroundColor: 'red !important',
                                color: 'white !important',
                                '&:hover': {
                                    backgroundColor: '#cc0000', // darker red on hover
                                },
                                '&:focus': {
                                    backgroundColor: '#cc0000',
                                },
                            }}
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
                <Grid
                    container
                    justifyContent="center"
                    alignItems="flex-start"
                    sx={{ position: "relative", minHeight: 100 }}
                >
                    {attorneys && attorneys?.length > 0 && (
                        <Grid item sx={{ top: 0, zIndex: 1 }}>
                            <FormControl sx={inputStyle}>
                                <InputLabel id="select-label">Attorney</InputLabel>
                                <Select
                                    labelId="select-label"
                                    label="Attorney"
                                    value={selectedAttorney}
                                    onChange={(e) => {
                                        setSelectedAttorney(e.target.value);
                                        setNewExpense({ ...newExpense, attorney: e.target.value });
                                    }}
                                    sx={{ height: 43 }}
                                >
                                    {attorneys.map((attorney) => (
                                        <MenuItem key={attorney.value} value={attorney.value}>
                                            {attorney.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}


                    {/* <Grid item sx={{ top: 0, zIndex: 0 }}>
                        <TextField
                            label="Month"
                            type="month"
                            defaultValue="2025-07"
                            InputLabelProps={{ shrink: true }}
                            sx={inputStyle}
                        />
                    </Grid> */}
                    <MDBox display="flex" justifyContent="flex-end" >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setOpenAddDialog(true)}
                            sx={{
                                backgroundColor: "#1976d2",
                                color: "#fff !important",

                            }}
                        >
                            Add New Expense
                        </Button>
                    </MDBox>

                    <Dialog open={openAddDialog} onClose={() => setOpenAddDialog(false)}>
                        <DialogTitle>Add New Expense</DialogTitle>
                        <DialogContent>
                            <TextField
                                margin="dense"
                                label="Month"
                                type="month"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={newExpense.selectedDate}
                                onChange={(e) => {
                                    setNewExpense({
                                        ...newExpense,
                                        selectedDate: e.target.value,
                                        date: dayjs(e.target.value + "-01").format("MMMM YYYY")
                                    })
                                }}
                            />

                            <TextField
                                margin="dense"
                                label="Attorney Direct Expenses"
                                fullWidth
                                type="number"
                                value={newExpense.AttorneyDirectExpenses}
                                onChange={(e) =>
                                    setNewExpense({ ...newExpense, AttorneyDirectExpenses: e.target.value })
                                }
                            />
                            <TextField
                                margin="dense"
                                label="Total General Expenses"
                                fullWidth
                                type="number"
                                value={newExpense.TotalGeneralExpenses}
                                onChange={(e) =>
                                    setNewExpense({ ...newExpense, TotalGeneralExpenses: e.target.value })
                                }
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenAddDialog(false)}>Cancel</Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    // Optional: Save to backend or local state
                                    setpersistedExpensesRows((prev) => [...prev, newExpense]);
                                    setOpenAddDialog(false);
                                    addNewExpense();

                                }}
                            >
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>



                </Grid>
                <Grid item xs={12}>
                    <Card>
                        {!loadingpersistedExpenses && selectedAttorney && filtredExpenses && (
                            <>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >

                                    <MDTypography variant="h6" color="white">
                                        Persisted Expenses
                                    </MDTypography>
                                </MDBox>

                                <MDBox>
                                    <DataTable
                                        table={{ columns: persistedExpensesColumns, rows: filtredExpenses }}
                                        isSorted={true}
                                        entriesPerPage={false}
                                        showTotalEntries={false}
                                        noEndBorder
                                    />
                                </MDBox>

                            </>

                        )}
                    </Card>
                </Grid>
            </MDBox>

        </DashboardLayout>
    );
}

export default Expenses;